import './HomeContactus.css';

function HomeConactus(){
    return(
        <div className='contactus-form' id='contactus'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-7'>
                        <h2 className='heading2'>Contact Us</h2>
                        <p>
                            <span><strong>Query</strong>LEI Services</span>
                            <span><strong>Contact</strong>LEI - Operations Team</span>
                            <span><strong>Email</strong>ni.oc.aidnilicc@iel</span>
                            <span><strong>Telephone</strong>Toll Free No - 18002106990</span>
                        </p>
                        <ul className='contact-listing'>
                            <li>
                                <h3 className='heading3'>Registered Office Address</h3>
                                <p>Legal Entity Identifier India Limited (LEIL) (The Clearing Corporation of India Ltd.) CCIL Bhavan, S. K. Bole Road, Dadar (West), Mumbai - 400 028</p>
                            </li>
                            <li>
                                <h3 className='heading3'>Working Days and Timings</h3>
                                <p><strong>Monday to Friday:</strong> 10:00 a.m. to 6:00 p.m.</p>
                                <p><strong>Saturdays:</strong> First , Third and Fifth Saturday (of any given month): 10:00 a.m. to 6:00 p.m.</p>
                            </li>
                            <li>
                                <h3 className='heading3'>Holidays</h3>
                                <p>All Bank Holidays as applicable in Maharashtra. Second and Fourth Saturday and all Sundays.</p>
                            </li>
                        </ul>
                    </div>
                    <div className='col-md-5'>
                        <form className='home-form'>
                            <h2 className='heading2'>Enquiry</h2>
                            <ul>
                                <li>
                                    <label>your name *</label>
                                    <div className='row'>
                                        <div className='col-md-6'><input type='text' placeholder='First Name' /></div>
                                        <div className='col-md-6'><input type='text' placeholder='Last Name' /></div>
                                    </div>
                                </li>
                                <li>
                                    <label>e-mail address *</label>
                                    <input type='text' placeholder='Eg. example@email.com' />
                                </li>
                                <li>
                                    <label>Company Name/Pan Number of Company Name *</label>
                                    <input type='text' placeholder='Company Name/Pan Number of Company Name' />
                                </li>
                                <li>
                                    <label>Contact Number *</label>
                                    <input type='text' placeholder='Contact Number' />
                                </li>
                                <li>
                                    <label>Application Type *</label>
                                    <select>
                                        <option>New</option>
                                        <option>Renewal</option>
                                        <option>Other Related Topic</option>
                                    </select>
                                </li>
                                <li>
                                    <label>Subject *</label>
                                    <select>
                                        <option>Status of application </option>
                                        <option>Process of registration</option>
                                        <option>Prices of registration & renewal</option>
                                        <option>Online form /payment related query</option>
                                        <option>Others</option>
                                    </select>
                                </li>
                                <li>
                                    <label>message *</label>
                                    <textarea placeholder='Please enter your comments...'></textarea>
                                </li>
                                <li>
                                    <button>submit <i className='fas fa-chevron-right'></i></button>
                                </li>
                            </ul>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}export default HomeConactus;